import authinterceptor from './authinterceptor';
import gloadingInterceptor from './gloadingInterceptor';

export function configureInterceptors() {
  authinterceptor();
  gloadingInterceptor();
}
